import type { AppConfig } from "@voxmedia/duet-context/context/config-context";

export const ADMIN_SECRET = "DUET";
export const ADMIN_DEV_PHRASE = "DEV";
export const ADMIN_EDIT_SHORTCUT = "?";
export const DEPLOY_ENV = process.env.NEXT_PUBLIC_DEPLOY_ENV || "dev";

// Session
export const AUTHENTICATED_COOKIE_NAME = "duet:authenticated";

// Sentry
export const SENTRY_CLIENT_SAMPLE_RATE = process.env
  .NEXT_PUBLIC_SENTRY_CLIENT_SAMPLE_RATE
  ? Number.parseFloat(process.env.NEXT_PUBLIC_SENTRY_CLIENT_SAMPLE_RATE)
  : 1.0;

// Component/Layout Configuration
export const RIVER_SECTION_SIZE = 6;
export const PAGINATION_LIMIT = 15;

export const AUTHOR_POSTS_PER_PAGE = 10;
export const CATEGORY_POSTS_PER_PAGE = 40;
export const HOMEPAGE_POSTS_PER_PAGE = 15;
export const HOMEPAGE_ARCHIVE_POSTS_PER_PAGE = 40;
export const STREAM_POSTS_PER_PAGE = 25;
export const STREAM_LOAD_MORE = 15;
export const PACKAGES_POSTS_PER_PAGE = 10;
export const PACKAGES_LOAD_MORE = 15;
export const FULL_ARCHIVES_POSTS_PER_PAGE = 15;

// 6 for pattern + 1 overfetch to filter current post
export const LATEST_RECIRC_LIMIT = 7;

// Branded Content
const DEFAULT_BRANDED_CONTENT_DISCLAIMER =
  "This advertising content was produced in collaboration between Vox Creative and our sponsor, without involvement from Vox Media editorial staff.";

// Config used for Config/UI Context
export const appConfig: AppConfig = {
  deployEnv: DEPLOY_ENV,
  defaultBrandedContentDisclaimer: DEFAULT_BRANDED_CONTENT_DISCLAIMER,
};

export const CHORUS_DO_NOT_TRACK_COOKIE = "_chorus_ccpa_consent_donotsell";

export const SENSITIVE_VIDEO_WARNING =
  "This video contains sensitive or violent content";
